/* eslint-disable max-len */
import React, { Component } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import LoadingState from "../loading-state/index";

const mapStyles = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  zoomControl: false,
  scaleControl: false,
  scrollwheel: false,
  navigationControl: false,
  draggable: false,
};

// eslint-disable-next-line react/prefer-stateless-function
export class DynamicMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: null,
      selectedPlace: {},
      mapLoaded: false,
      mapData: {},
    };
  }

  onMarkerClick = (marker) => {
    if (marker !== null) {
      this.setState(() => ({
        selectedPlace: {
          name: this.props.mapData ? this.props.mapData.currentAddress : "",
        },
        activeMarker: marker,
        showingInfoWindow: true,
      }));
    }
  };

  onClose = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  handleMapIdle = () => {
    this.setState({
      mapLoaded: true,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    // Guard against rapid mapData changes that could cause excessive re-renders
    // Only reset map when mapData coordinates actually change
    if (prevProps.mapData !== this.props.mapData) {
      const prevLat = prevProps.mapData ? parseFloat(prevProps.mapData.latitude) : null;
      const prevLng = prevProps.mapData ? parseFloat(prevProps.mapData.longitude) : null;
      const currentLat = this.props.mapData ? parseFloat(this.props.mapData.latitude) : null;
      const currentLng = this.props.mapData ? parseFloat(this.props.mapData.longitude) : null;

      // If coordinates changed or mapData went from empty to populated, reset map
      if ((prevLat !== currentLat || prevLng !== currentLng) && currentLat && currentLng) {
        // Reset mapLoaded to allow marker to re-render at new position
        if (this.state.mapLoaded) {
          this.setState({
            mapLoaded: false,
            showingInfoWindow: false,
            activeMarker: null,
          });
        }
      }
    }

    // If map was previously loading and now has data, close any open info window
    if (prevProps.isMapLoading && !this.props.isMapLoading && this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  }

  render() {
    // console.log("insode teheheh", this.props);

    const center = {
      lat: this.props.mapData ? parseFloat(this.props.mapData.latitude) : 0,
      lng: this.props.mapData ? parseFloat(this.props.mapData.longitude) : 0,
    };

    return (
      <React.Fragment>
        {Object.keys(this.props.mapData).length > 0 &&
          !this.props.isMapLoading && (
            <GoogleMap
              mapContainerStyle={mapStyles}
              zoom={14}
              center={center}
              options={mapOptions}
              onIdle={this.handleMapIdle}
            >
              {this.state.mapLoaded && (
                <Marker
                  position={center}
                  onClick={(e) => this.onMarkerClick(e.domEvent.target)}
                />
              )}
              {this.state.showingInfoWindow && this.state.activeMarker && (
                <InfoWindow position={center} onCloseClick={this.onClose}>
                  <div>
                    <h4>
                      {this.props.mapData
                        ? this.props.mapData.currentAddress
                        : ""}
                    </h4>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          )}
        {Object.keys(this.props.mapData).length === 0 &&
          this.props.mapError && (
            <div className="no-map-msg">
              <span>
                <i className="icon-close" />
              </span>
              <span>
                Tracking information currently unavailable. Please try again
                later.
              </span>
            </div>
          )}
        {this.props.isMapLoading && !this.props.mapError && <LoadingState />}
      </React.Fragment>
    );
  }
}

export default DynamicMap;
